import React from 'react';
import {
  BankIllustration,
  BankSuccessIllustration,
  BusinessesIllustration,
  EmptyStateIllustration,
  ErrorIllustration,
  MoneySuccessIllustration,
  NoResultsIllustration,
  PaymentsIllustration,
  PendingIllustration,
  SuccessIllustration
} from '../assets/Illustrations';

export type IllustrationType =
  | 'emptyState'
  | 'error'
  | 'noResults'
  | 'success'
  | 'pending'
  | 'payments'
  | 'moneySuccess'
  | 'businesses'
  | 'bank'
  | 'bankSuccess';

export interface IllustrationsProps {
  type: IllustrationType;
}

export const Illustration: React.FC<IllustrationsProps> = ({ type }) => {
  const getIllustration = () => {
    switch (type) {
      case 'emptyState':
        return <EmptyStateIllustration />;
      case 'error':
        return <ErrorIllustration />;
      case 'noResults':
        return <NoResultsIllustration />;
      case 'success':
        return <SuccessIllustration />;
      case 'pending':
        return <PendingIllustration />;
      case 'payments':
        return <PaymentsIllustration />;
      case 'moneySuccess':
        return <MoneySuccessIllustration />;
      case 'businesses':
        return <BusinessesIllustration />;
      case 'bank':
        return <BankIllustration />;
      case 'bankSuccess':
        return <BankSuccessIllustration />;
      default:
        return null;
    }
  };

  return <div>{getIllustration()}</div>;
};
